import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { ReservationRepository } from '../repositories/reservation.respository';

export class ClearReservationUseCase implements UseCase<unknown, boolean> {
    constructor(private readonly repository: ReservationRepository) {}

    execute(): Observable<boolean> {
        return this.repository.clearReservation();
    }
}
